import React, { useState } from "react";
import { Form } from "react-bootstrap";
import SelectSearchControl from "../InputControls/SelectSearchControl";
import { useStateValue } from "../../../store/StateProvider";
import { getSellerCreationErrors, getFieldValidationErrors } from "../../../utils/validator";
import locationLabelsIntl from "../../../constants/locationLabelsIntl";

const InputSelectSearch = ({ fieldConfig, showErrors }) => {
  const [{ hiddenFields, sellerCreationErrors, formValues, registrationCountry }] = useStateValue();
  const sellerCreationFieldError = getSellerCreationErrors(fieldConfig.id, sellerCreationErrors);
  const [errorMessage, setErrorMessage] = useState(sellerCreationFieldError);
  const [firstLoad, setFirstLoad] = useState(true);

  const labelClass = `input_label_plain ${fieldConfig.labelClass}`;

  const setError = error => {
    setErrorMessage(error);
  };

  const executeFieldValidation = validators => {
    const error = getFieldValidationErrors(validators, formValues, fieldConfig.id);
    setError(error);
  };

  const label = fieldConfig.labelByRegistrationCountry
    ? (locationLabelsIntl?.[registrationCountry?.code]?.[fieldConfig.id] ?? fieldConfig.label)
    : fieldConfig.label;

  return (
    <Form.Group
      className={`mb3 ${fieldConfig.containerClass} ${hiddenFields.includes(fieldConfig.id) ? "hidden" : ""}`}
      id={`container_${fieldConfig.id}`}
      controlId={fieldConfig.name}>
      <Form.Label className={labelClass}>{label}</Form.Label>
      <Form.Label className="label_description">{fieldConfig.labelDescription}</Form.Label>
      <SelectSearchControl
        fieldConfig={fieldConfig}
        fieldValidator={executeFieldValidation}
        removeErrorMessage={setError.bind(this, null)}
        hasError={!!errorMessage}
        setFirstLoad={setFirstLoad}
        firstLoad={firstLoad}
        showErrors={showErrors}
      />
      <Form.Label
        className={`label_error ${!!errorMessage && (!firstLoad || showErrors || sellerCreationFieldError) ? "show" : "hidden"}`}
        id={`label_error_${fieldConfig.id}`}>
        <span id={`label_error_message_${fieldConfig.id}`}>{errorMessage}</span>
      </Form.Label>
    </Form.Group>
  );
};

export default InputSelectSearch;
